import React from "react";
import Plus from "../Icons/Plus";
import Contact from './Contact'

const MobileContact = (props) => {
  return (
    <aside
      id="mobilepopup"
      className="popup_container"
      aria-label="Mobile contact popup"
    >
      <Contact resources={props.resources}></Contact>
      <button className="mobile__close contact-mobile-close">
        <span className="close__dummy">close button</span>
        <Plus></Plus>
      </button>
    </aside>
  );
};
export default MobileContact;
